import { truncateDoubleTo } from "./truncateDoubleTo";

export function oddToStringCheckbet(odd) {
	return truncateDoubleTo(parseFloat(odd / 100.00), 2);
}
